var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFuse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    id: "svg5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2435",
    transform: "matrix(1.878968,0,0,3.0144219,-93.096285,-123.32817)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f2f2f2",
      stroke: "#000000",
      strokeWidth: 0.964999,
      strokeLinecap: "round",
      strokeMiterlimit: 4.5,
      paintOrder: "stroke fill markers"
    },
    id: "rect846",
    width: 110.28308,
    height: 98.272064,
    x: 50.773895,
    y: 41.492645
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f2f2f2",
      stroke: "#008200",
      strokeWidth: 2.065,
      strokeLinecap: "round",
      strokeMiterlimit: 4.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    id: "rect1393",
    width: 20.200367,
    height: 53.503674,
    x: 61.693016,
    y: 62.784927
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f2f2f2",
      stroke: "#f727f2",
      strokeWidth: 2.165,
      strokeLinecap: "round",
      strokeMiterlimit: 4.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    id: "rect1725",
    width: 20.200367,
    height: 53.503674,
    x: 129.39154,
    y: 62.784927
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 106.4425,97.591794 -2.23895,-0.56886 13.16698,-3.2676 H 89.384032 v -0.79375 h 27.986498 l -13.16698,-3.26761 2.23895,-0.56885 17.05843,4.23333 z",
    id: "path2422",
    style: {
      strokeWidth: 0.531117
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFuse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fuse.e48bec69.svg";
export { ForwardRef as ReactComponent };